import React, { Component, createRef } from "react"

import styled from "styled-components"
import Link from "./localizedLink"
import { TransitionPortal } from "gatsby-plugin-transition-link"
import gsap, { Power1 } from "gsap"

export default class extends Component {
  cover1 = createRef()

  animateExit = ({ length }, node) => {
    return gsap
      .timeline()
      .set(this.cover1, { y: "-100%" })
      .to(this.cover1, { duration: length / 2, y: "0%", ease: Power1.easeIn })
      .to(this.cover1, {
        duration: length / 2,
        y: "100%",
        ease: Power1.easeOut,
      })
      .set(node, { opacity: 0 }, `-=${length / 2}`)

    // return gsap.timeline().to(node, { duration: length / 2, opacity: 0 })
  }

  animateEntry = ({ length }, node) => {
    return gsap.timeline().set(node, { opacity: 1 })

    // return (
    //   gsap
    //     .timeline()
    //     .set(node, { opacity: 0 })
    //     .to(node, { duration: length, opacity: 1 })
    // )
  }

  render() {
    const duration = 1

    return (
      <>
        <Link
          exit={{
            length: duration,
            delay: 0,
            trigger: ({ exit, node }) => this.animateExit(exit, node),
          }}
          entry={{
            length: duration,
            delay: duration / 2,
            trigger: ({ entry, node }) => this.animateEntry(entry, node),
          }}
          {...this.props}
        />
        <TransitionPortal>
          <Cover1 ref={el => (this.cover1 = el)}></Cover1>
        </TransitionPortal>
      </>
    )
  }
}

const Cover = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: block;
  width: 100vw;
  height: 100vh;
  transform-origin: center;
  transform: translate(0, -100%);
`
const Cover1 = styled(Cover)`
  z-index: 10000;
  background: ${({ theme }) => theme.colors.accent};
`
